import ViewCoursePage from './ViewCoursePage'
export default ViewCoursePage;